// QA ON-12: a blocked sign-up stays blocked in this browser. The sign-in card keeps the blocked footer
// ("Back" / "Business accounts get access straight away.") until someone signs in with a business email.
const KEY = "plgSignupBlocked";

export function rememberSignupBlocked(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    // storage unavailable: the footer falls back to the normal one
  }
}

export function isSignupBlocked(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function clearSignupBlocked(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
